/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Legend_InheritedInputs */



/**
* | output |
* | --- |
* | "Inherited (everyone value only)" |
*
* @param {Rights_Tools_Legend_InheritedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_legend_inherited = /** @type {((inputs?: Rights_Tools_Legend_InheritedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Legend_InheritedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geerbt (nur Wert für „Alle“)")
	return /** @type {LocalizedString} */ ("Inherited (everyone value only)")
});